import { Component } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '@environments/environment';
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';
import { TranslateModule } from '@ngx-translate/core';
import { AppNavigationComponent } from '@layout/components/app-navigation/app-navigation.component';
import { TrapFocusDirective } from '@shared/directives/trap-focus.directive';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {
        '(window:resize)': 'onScreenResize($event)',
    },
    standalone: true,
    imports: [ButtonModule, SidebarModule, TranslateModule, AppNavigationComponent, TrapFocusDirective],
})
export class MobileMenuComponent {
    isSidebarVisible = false;
    routerSubscription!: Subscription;

    readonly quickorderDashboardUrl = environment.quickorderDashboardUrl;

    constructor(private router: Router) {}

    toggleSidebar(): void {
        this.isSidebarVisible = !this.isSidebarVisible;
    }

    onScreenResize(event: any) {
        if (event.target.innerWidth <= 990) {
            this.routerSubscription = this.router.events.subscribe((event: any) => {
                if (event instanceof NavigationStart && this.isSidebarVisible) {
                    this.isSidebarVisible = false;
                }
            });
        }

        if (event.target.innerWidth > 991) {
            this.isSidebarVisible = false;
            this.routerSubscription?.unsubscribe();
        }
    }
}
